import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import {
  saveGlassgowCommaScore,
  setEyePNNV,
  setGlassgowCommaScoreData,
  setMotorPNNV,
  setVerbalPNNV,
} from '../store/glassgowCommaScore.actions'
import { IGCSOptionsState } from '../../../../options/store/options.types'
import { NeuroConstants } from '../../store/neuro.constants'
import { getGCSOptionsSelector } from '../../../../options/selectors/gcsOptions.selector'
import { INeuroState } from '../../store/neuro.types'
import { getNeuroSelector } from '../../selectors'
import { getDatapointsConfigSelector } from '../../../../configurations/selectors'
import { IDataPointsConfig } from '../../../../configurations/store/configurations.types'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* setCustomGlassgowCommaScore() {
  try {
    const neuroStateData: INeuroState = yield select(getNeuroSelector)
    const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
    const { DP_INITGCS } = datapointsConfig
    const { chemParalyzed } = neuroStateData
    if (chemParalyzed && DP_INITGCS) {
      const gcsOptionsStateData: IGCSOptionsState = yield select(getGCSOptionsSelector)
      const { gcsEyeResponseOptions, gcsVerbalResponseOptions, gcsMotorResponseOptions } = gcsOptionsStateData
      const gcsEye = gcsEyeResponseOptions.find((optionsObj) => optionsObj.name === 'None')
      const gcsMotor = gcsMotorResponseOptions.find((optionsObj) => optionsObj.name === 'None')
      const gcsVerbal = gcsVerbalResponseOptions.find((optionsObj) => optionsObj.name === 'None')
      yield put(setGlassgowCommaScoreData({ gcsEye, gcsMotor, gcsVerbal }))
      yield put(setEyePNNV(null))
      yield put(setVerbalPNNV(null))
      yield put(setMotorPNNV(null))
      yield put(saveGlassgowCommaScore())
    }
  } catch (e) {
    yield put(throwPcrException(`setCustomGlassgowCommaScore() error: ${e}`))
  }
}

export function* setCustomGlassgowCommaScoreSaga() {
  yield takeLatest([NeuroConstants.SET_CHEMPARALYZED], performWithMutexHOG, setCustomGlassgowCommaScore)
}
